import { Box, Title, Spinner } from '@nimbus-ds/components';

interface LabelProgressTitleProps {
  title: string;
}

function LabelProgressTitle({ title }: Readonly<LabelProgressTitleProps>) {
  return (
    <Box alignItems="center" display="flex" gap="2">
      <Title as="h5">{title}</Title>
      <Spinner size="small" color="currentColor" />
    </Box>
  );
}

export default LabelProgressTitle;
